import React, {useState, useEffect} from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import "./Css/Footer.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleUp } from '@fortawesome/free-solid-svg-icons';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';

const Footer = () => {
  
  const [isVisible, setIsVisible] = useState(false);

  // Show button after scrolling 100px
  const toggleVisibility = () => {
    if (window.pageYOffset > 100) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', toggleVisibility);
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);
  return (
    <div className='footer-sec'>
      <Container>
        <div className='top-footer'>
          <Row className='d-flex align-items-center text-center'>
            <Col xs={12} lg={3}>

              <h4 className='footer-title'>
                Address
              </h4>
              <p className='footer-content'>
                Ista, kaakatiya hills, 460, Road No. 9, near Ista, Kakatiya Hills, Madhapur, Hyderabad, Telangana 500081
              </p>
            </Col>
            <Col xs={12} lg={3}>

              <h4 className='footer-title'>
                Contact
              </h4>
              <p className='footer-content'>
                srimahacaterers.dm@gmail.com              <br />
                +91 89777 81366 / 69
              </p>
            </Col>
            <Col xs={12} lg={3}>

              <h4 className='footer-title'>
                Timings
              </h4>
              <p className='footer-content'>
                Everyday <br /> 9:00 AM – 6:00 PM
              </p>
            </Col>
            <Col xs={12} lg={3}>

              <h4 className='footer-title'>
                Social Media
              </h4>
              <p className='footer-content'>
                <a href='https://www.facebook.com/share/1Bv3XMoRt7/?mibextid=wwXIfr' target='_blank' rel='noreferrer' title='Facebook'>
                  Facebook
                </a>
                <br />
                <a href='https://www.instagram.com/srimahacaterers?igsh=ZDRzejc2ajI4azlq' target='_blank' rel='noreferrer' title='Instagram'>
                  Instagram
                </a>
                <br />
                <a href='https://x.com/srimahacaterers?s=11' target='_blank' rel='noreferrer' title='Twitter'>
                  Twitter
                </a>
                <br />
                <a href='https://youtube.com/@srimahacaterers?si=FjldBFGuyyZ-l3JV' target='_blank' rel='noreferrer' title='Youtube'>
                  Youtube
                </a>
              </p>
            </Col>
          </Row>
        </div>
        <hr />
        <div className='bottom-footer'>
          <div className='copyright'>
            <p>
              &copy; {new Date().getFullYear()} Sri Maha Caterers
            </p>
          </div>
          <div className='footer-links'>
            <ul className='d-flex gap-3'>
              <li>
                <a href='/' title='Privacy Policy'>Privacy Policy</a>
                
              </li>
              <li>                
                <a href='/' title='Terms of Use'>Terms of Use</a>
              </li>
            </ul>
          </div>
        </div>
         {isVisible && (
       <>
        <button className='scrollTop' onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
          <FontAwesomeIcon icon={faAngleUp}  />
        </button>        
      </>
      )}
      <a
        href="https://wa.me/+918977781366"
        class="whatsapp-float"
        target="_blank"
        rel="noopener noreferrer"
      >
        <FontAwesomeIcon icon={faWhatsapp} />
      </a>
        

      </Container>
    </div>
  )
}

export default Footer